// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {Spec} from 'immutability-helper';
import React from 'react';

import {ArchiveRecord} from 'archive/ArchiveConstants';
import {Permissions} from 'auth/PermissionConstants';
import {TagSchema} from 'constants/RegistryConstants';
import {SchemaTag} from 'folder-items/FileConstants';
import ProxyFile from 'folder-items/ProxyFile';
import {EntryProtocol, FromServerEntryProtocol} from 'notebook/ELNConstants';
import TemplateActions from 'notebook/entry-templates/TemplateActions';
import {
  FromServerTemplate,
  FromServerTemplateVersion,
  Template,
  TemplateCollectionSummary,
} from 'notebook/entry-templates/TemplateConstants';
import TemplateStore from 'notebook/entry-templates/TemplateStore';
import {ItemEditorState} from 'notebook/store/VersionedItemSubstore';
import {NotePart} from 'notebook/util/NoteUtilConstants';
import BaseEntryStore from 'stores/BaseEntryStore';

class TemplateFile extends ProxyFile<Template, typeof TemplateStore> {
  static initClass(): void {
    this.prototype.proxiedField = 'template';
  }

  templateCollection(): TemplateCollectionSummary {
    return this.proxied().templateCollection;
  }

  latestVersionId(): number {
    return this.proxied().latestVersionId;
  }

  entryProtocols(): Array<EntryProtocol> {
    return this.proxied().templateVersion.entryVersion.entryProtocols;
  }

  getStore(): BaseEntryStore<
    Template,
    FromServerTemplate,
    FromServerTemplateVersion,
    'template',
    'templateId'
  > {
    return TemplateStore;
  }

  getState(): ItemEditorState<Template, NotePart, 'template', 'templateId'> {
    return this.getStore().getEditorState(this.id);
  }

  openTemplateVersion = (): void => {
    TemplateActions.loadVersion(this.id, this.latestVersionId());
  };

  setBanner(): void {
    if (!this.isLatest()) {
      const prevVersionMessage = (
        <span>
          Editing is disabled on previous versions. View the{' '}
          <a
            onClick={() => {
              this.openTemplateVersion();
            }}
          >
            latest template version.
          </a>
        </span>
      );
      this.setBannerText(prevVersionMessage);
    } else if (this.isArchived()) {
      this.setBannerText('Editing is disabled on archived template.');
    } else if (!this.writable()) {
      this.setBannerText('Editing is disabled on read-only template.');
    } else {
      this.setBannerText(null);
    }
  }

  addProtocol(protocol: FromServerEntryProtocol): void {
    TemplateActions.addProtocol(this.id, this.proxied(), protocol);
  }

  updateProtocol(protocolCid: string, op: Spec<EntryProtocol>): void {
    TemplateActions.updateProtocol(this.id, this.proxied(), protocolCid, op);
  }

  removeProtocol(protocolCid: string): void {
    TemplateActions.removeProtocol(this.id, this.proxied(), protocolCid);
  }

  revertProtocol(protocol: EntryProtocol, selectionData: SelectionRestoreData): void {
    TemplateActions.revertProtocol(this.id, this.proxied(), protocol, selectionData);
  }

  reorderProtocols(cids: Array<string>): void {
    TemplateActions.reorderProtocols(this.id, this.proxied(), cids);
  }

  setArchiveRecord(archiveRecord: ArchiveRecord | null): void {
    // Do not bump version and trigger an autosave because archiveRecord is not a versioned field  and has
    // already been posted to the server. See `updateItem` in VersioneditemSubstore
    TemplateActions.update(this.id, {$merge: {archiveRecord}}, {cidIdMap: undefined, bumpVersion: false});
  }

  setPermissions(permissions: Permissions): void {
    // Do not bump version and trigger an autosave because archiveRecord is not a versioned field  and has
    // already been posted to the server. See `updateItem` in VersioneditemSubstore
    TemplateActions.update(this.id, {$merge: {permissions}}, {cidIdMap: undefined, bumpVersion: false});
  }

  load({versionId, deferred}: {versionId?: number | null; deferred: JQueryDeferred<void>}): void {
    if (this.proxied() != null && versionId != null) {
      // If it's already loaded and they are trying to load a version
      TemplateActions.loadVersion(this.id, versionId, {deferred});
    } else {
      // Otherwise, trigger a fresh open.
      TemplateActions.open(this.id, {versionId, deferred});
    }
  }

  cleanUp(): void {
    super.cleanUp();
    TemplateActions.close(this.id);
  }

  setTagSchema(tagSchema: TagSchema): void {
    TemplateActions.setTagSchema(this.id, tagSchema);
  }

  setTags(tags: Array<SchemaTag>): void {
    TemplateActions.setTags(this.id, tags);
  }

  async triggerUpdateNameAction(name: string): Promise<string> {
    if (name !== this.name()) {
      await TemplateActions.saveFileData(this.id, {data: {name}});
    }
    return this.name();
  }
}
TemplateFile.initClass();

export default TemplateFile;
